/* eslint-disable array-callback-return */
import BunkeyAPI from '../api/BunkeyAPI'
import {
  DOWNLOAD_CHUNKS_FILES,
  DOWNLOAD_DATA_EMPTY,
  DOWNLOAD_EMPTY,
  DOWNLOAD_ERROR,
  DOWNLOAD_RETRY,
  DOWNLOAD_START,
  DOWNLOAD_UPDATE,
  EMPTY_DATA_ACTIVE_DOWNLOAD,
  ERROR_SAVING_DATA_DOWNLOAD,
  HANDLE_CANCEL_DOWNLOAD_LIST,
  HANDLE_DEFAULT_LIST_DOWNLOAD_HISTORY,
  HANDLE_IS_DOWNLOADING,
  HANDLE_IS_FETCHING_HISTORY,
  HANDLE_ITEM_CANCEL_FROM_DOWNLOAD,
  HANDLE_MINE_OR_ALL,
  HANDLE_REFRESH_DOWNLOAD_HISTORY,
  HANDLE_SHOW_MULTIPLE_DOWNLOAD,
  HANDLE_SHOW_PROGRESS_INDICATOR,
  RESUME_DOWNLOAD_CANCEL,
  RESUME_DOWNLOAD_SHOW,
  SET_DOWNLOAD_FOLDER,
  SUCCESS_SAVING_DATA_DOWNLOAD
} from '../constants/download-types'
import store from '../store'
/**
 * 
 * @param {*} id 
 * @param {*} name 
 * @param {*} url 
 * @param {*} type 
 */
export const startDownload = item => {
  return dispatch => {
    dispatch({ type: DOWNLOAD_START, payload: item })
  }
}

/**
 * 
 * @param {*} id 
 */
export const updateDownload = (uuid, state) => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_UPDATE,
      payload: { uuid, state }
    })
  }
}
/**
 *
 * @param {*} id
 */
export const updateDownloadMultiple = (id, state) => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_UPDATE,
      payload: { id, state }
    })
  }
}

export const retryDownload = (currentUuid, item) => {
  const { data } = store.getState().downloads
  const filtered = data.filter(r => r.uuid !== currentUuid)
  filtered.push(item)
  return dispatch => {
    dispatch({
      type: DOWNLOAD_RETRY,
      payload: filtered
    })
  }
}

export const cancelAllDownload = () => {
  return dispatch => {
    dispatch({ type: DOWNLOAD_DATA_EMPTY })
  }
}
/**
 * 
 * @param {*} id 
 */
export const downloadError = id => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_ERROR,
      payload: id
    })
    dispatch(setDownloadFolder(false))
  }
}
/**
 * 
 */
export const resetDownloadReducer = () => {
  return dispatch => {
    dispatch({ type: DOWNLOAD_EMPTY })
  }
}
/**
 * 
 * @param {*} isDownloadFolder 
 * @author Victor Smith
 */
export const setDownloadFolder = isDownloadFolder => {
  return dispatch => {
    dispatch({
      type: SET_DOWNLOAD_FOLDER,
      payload: {
        isDownloadFolder,
      }
    })
  }
}
/**
 * 
 * @param {*} showProgressIndicator 
 * @author Victor Smith
 */
export const handleShowProgressIndicator = showProgressIndicator => {
  return dispatch => {
    dispatch({
      type: HANDLE_SHOW_PROGRESS_INDICATOR,
      payload: { showProgressIndicator }
    })
  }
}
/**
 * @param {*} emptyDataActiveDownload 
 * @author Victor Smith
 */
export const emptyDataActiveDownload = () => {
  return dispatch => {
    dispatch({ type: EMPTY_DATA_ACTIVE_DOWNLOAD })
  }
}
/**
 * 
 * @param {*} cancelDownloadList
 * @author Victor Smith
 */
export const handleCancelDownloadList = cancelDownloadList => {
  return dispatch => {
    dispatch({
      type: HANDLE_CANCEL_DOWNLOAD_LIST,
      payload: { cancelDownloadList }
    })
  }
}
/**
 * 
 * @param {*} handleItemCancelFromDownload
 * @author Victor Smith
 */
export const handleItemCancelFromDownload = itemCancelFromDownload => {
  return dispatch => {
    dispatch({
      type: HANDLE_ITEM_CANCEL_FROM_DOWNLOAD,
      payload: { itemCancelFromDownload }
    })
  }
}
/**
 * 
 * @param {*} saveDownload 
 * @author Victor Smith
 */
export const handleSaveDownload = saveDownload => {
  return dispatch => {
    const { workclient } = store.getState().client
    const { user } = store.getState().authUser
    BunkeyAPI({
      url: `/downloads/client/${workclient}`,
      method: 'POST',
      data: {
        saveDownload,
        user: user._id
      }
    }).then(resp => {
      dispatch({ type: SUCCESS_SAVING_DATA_DOWNLOAD })
    }).catch(err => {
      dispatch({ type: ERROR_SAVING_DATA_DOWNLOAD })
    })
  }
}
/**
 * 
 * @param {*} isFetchingHistory 
 * @name handleIsFetchingHistory
 * @author Victor Smith
 */
export const handleIsFetchingHistory = isFetchingHistory => {
  return dispatch => {
    dispatch({
      type: HANDLE_IS_FETCHING_HISTORY,
      payload: { isFetchingHistory }
    })
  }
}
/**
 * 
 * @param {*} isDownloading 
 * @name handleIsDownloading
 * @author Victor Smith
 */
export const handleIsDownloading = isDownloading => {
  return dispatch => {
    dispatch({
      type: HANDLE_IS_DOWNLOADING,
      payload: { isDownloading }
    })
  }
}
/**
 * 
 * @param {*} defaultListDownloadHistory 
 * @name handleDefaultListDownloadHistory
 * @author Victor Smith
 */
export const handleDefaultListDownloadHistory = defaultListDownloadHistory => {
  return dispatch => {
    dispatch({
      type: HANDLE_DEFAULT_LIST_DOWNLOAD_HISTORY,
      payload: { defaultListDownloadHistory }
    })
  }
}
/**
 * 
 * @param {*} mine 
 * @name handleMineOrAll
 * @author Victor Smith
 */
export const handleMineOrAll = mine => {
  return dispatch => {
    dispatch({
      type: HANDLE_MINE_OR_ALL,
      payload: { mine }
    })
  }
}

export const handleShowMultipleDownload = showMultipleDownload => {
  return dispatch => {
    dispatch({
      type: HANDLE_SHOW_MULTIPLE_DOWNLOAD,
      payload: { showMultipleDownload }
    })
  }
}

export const handleRefreshDownloadHistory = refreshDownloadHistory => {
  return dispatch => {
    dispatch({
      type: HANDLE_REFRESH_DOWNLOAD_HISTORY,
      payload: { refreshDownloadHistory }
    })
  }
}

export const resumeDownload = id => {
  return dispatch => {
    dispatch({
      type: RESUME_DOWNLOAD_SHOW,
      payload: id
    })
  }
}

export const resumeDownloadCancel = () => {
  return dispatch => {
    dispatch({ type: RESUME_DOWNLOAD_CANCEL })
  }
}

export const updateDownloadChunks = (uuid, total, current) => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_CHUNKS_FILES,
      payload: { uuid, total, current }
    })
  }
}
